import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import { THEME_COLOR } from "../../../../styles/colors";
import OutlineCard from "../../OutlineCard";

const ComparisonOption = ({ option }) => (
  <Column width="50%" spacing="200">
    {option?.label && <Text type="h50">{option.label}</Text>}
    {option?.points?.length > 0 && (
      <Text type="b200" color="secondary" tag="ul">
        {option.points.map((p, i) => <li key={i}>{p}</li>)}
      </Text>
    )}
  </Column>
);

const ComparisonCard = ({ title, optionA, optionB }) => (
  <OutlineCard title={title}>
    <Row spacing="100">
      <ComparisonOption option={optionA} />
      <Box backgroundColor={THEME_COLOR.MIST_GRAY} width={1} />
      <ComparisonOption option={optionB} />
    </Row>
  </OutlineCard>
);

export default ComparisonCard;
